import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-7e4c382c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" }
const _hoisted_2 = { class: "card-body p-15" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "fs-4 text-black fw-semibold mb-10 text-center" }, "Reprendre la session", -1))
const _hoisted_4 = {
  key: 0,
  class: "text-center"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-10" }, "Chargement des questions...", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-primary",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Chargement...")
], -1))
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = {
  key: 1,
  class: "results-container"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "mb-20" }, "Test Terminé !")
], -1))
const _hoisted_10 = { class: "row gx-2" }
const _hoisted_11 = { class: "col-md-3" }
const _hoisted_12 = { class: "result-card p-15 mb-5 bg-success-subtle" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "text-primary" }, "Score", -1))
const _hoisted_14 = { class: "fs-1 fw-bold text-success" }
const _hoisted_15 = { class: "col-md-3" }
const _hoisted_16 = { class: "result-card p-15 mb-5 bg-success-subtle" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "text-primary" }, "Pourcentage", -1))
const _hoisted_18 = { class: "col-md-3" }
const _hoisted_19 = { class: "result-card p-15 mb-5 bg-success-subtle" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "text-primary" }, "Bonnes réponses", -1))
const _hoisted_21 = { class: "fs-1 fw-bold text-success" }
const _hoisted_22 = { class: "col-md-3" }
const _hoisted_23 = { class: "result-card p-15 mb-5 bg-success-subtle" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "text-primary" }, "Mauvaises réponses", -1))
const _hoisted_25 = { class: "fs-1 fw-bold text-danger" }
const _hoisted_26 = { class: "text-start mt-10" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "mb-15 text-center" }, "📋 Revue détaillée de vos réponses", -1))
const _hoisted_28 = { class: "questions-review" }
const _hoisted_29 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_30 = { class: "mb-0 fw-bold" }
const _hoisted_31 = { class: "question-number" }
const _hoisted_32 = { class: "question-content p-10 bg-white" }
const _hoisted_33 = { class: "fw-semibold mb-10 text-black" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", { class: "text-black" }, "Votre réponse :", -1))
const _hoisted_35 = {
  key: 0,
  class: "correct-answer-display p-10 bg-success-subtle rounded"
}
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", { class: "text-success" }, "✓ Bonne réponse :", -1))
const _hoisted_37 = { class: "ms-2 text-success fw-bold" }
const _hoisted_38 = {
  key: 0,
  class: "text-start mt-20"
}
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "mb-10" }, "📜 Historique des scores ", -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "alert alert-info mb-10" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Note :"),
  /*#__PURE__*/_createTextVNode(" Cet historique inclut le score de la session originale et tous les scores des reprises effectuées. ")
], -1))
const _hoisted_41 = { class: "table-responsive" }
const _hoisted_42 = { class: "table text-nowrap align-middle mb-0 table-bordered" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", { class: "table-light" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-2 pb-2"
    }, " Type "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-2 pb-2"
    }, " Tentative "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-2 pb-2"
    }, " Score "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-2 pb-2"
    }, " Total "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-2 pb-2"
    }, " Pourcentage "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-2 pb-2"
    }, " Bonnes "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-2 pb-2"
    }, " Mauvaises "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-2 pb-2"
    }, " Date ")
  ])
], -1))
const _hoisted_44 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_45 = {
  key: 0,
  class: "badge bg-primary"
}
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-star me-1" }, null, -1))
const _hoisted_47 = {
  key: 1,
  class: "badge bg-secondary"
}
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-refresh me-1" }, null, -1))
const _hoisted_49 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_50 = { class: "shadow-none lh-1 fw-bold text-black-emphasis" }
const _hoisted_51 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_52 = { class: "shadow-none lh-1 fw-bold" }
const _hoisted_53 = { class: "shadow-none lh-1 fw-medium text-success" }
const _hoisted_54 = { class: "shadow-none lh-1 fw-medium text-danger" }
const _hoisted_55 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_56 = {
  key: 0,
  class: "row mt-15 gx-2"
}
const _hoisted_57 = { class: "col-md-12" }
const _hoisted_58 = { class: "alert alert-success" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "mb-10" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-chart-line me-2" }),
  /*#__PURE__*/_createTextVNode("Analyse de progression")
], -1))
const _hoisted_60 = { class: "row" }
const _hoisted_61 = { class: "col-md-4" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Meilleur score :", -1))
const _hoisted_63 = { class: "ms-2 text-success fw-bold" }
const _hoisted_64 = { class: "col-md-4" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Score moyen :", -1))
const _hoisted_66 = { class: "ms-2 text-primary fw-bold" }
const _hoisted_67 = { class: "col-md-4" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Nombre de tentatives :", -1))
const _hoisted_69 = { class: "ms-2 text-info fw-bold" }
const _hoisted_70 = { class: "d-flex justify-content-center gap-3 mt-20" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-refresh me-1" }, null, -1))
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-list me-1" }, null, -1))
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-history me-1" }, null, -1))
const _hoisted_74 = {
  class: "progress mb-20",
  style: {"height":"8px"}
}
const _hoisted_75 = {
  key: 0,
  class: "form-group mb-10"
}
const _hoisted_76 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_77 = { class: "alert alert-info" }
const _hoisted_78 = {
  key: 1,
  class: "form-group mb-10"
}
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Sélectionner une réponse "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_80 = {
  key: 0,
  class: "border border-primary p-10"
}
const _hoisted_81 = { class: "d-flex align-items-center mb-5" }
const _hoisted_82 = ["for"]
const _hoisted_83 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_84 = {
  key: 2,
  class: "form-group mb-10"
}
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Votre réponse "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_86 = {
  key: 3,
  class: "form-group mb-10"
}
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Sélectionner une réponse "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_88 = { class: "border border-primary p-10" }
const _hoisted_89 = { class: "d-flex align-items-center mb-5" }
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "text-black",
  for: "oui",
  style: {"cursor":"pointer"}
}, "Oui", -1))
const _hoisted_91 = { class: "d-flex align-items-center mb-5" }
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "text-black",
  for: "non",
  style: {"cursor":"pointer"}
}, "Non", -1))
const _hoisted_93 = { class: "d-flex align-items-center mt-10" }
const _hoisted_94 = ["disabled"]
const _hoisted_95 = ["disabled"]
const _hoisted_96 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-1"
}
const _hoisted_97 = {
  key: 4,
  class: "mt-10"
}
const _hoisted_98 = { class: "text-danger" }
const _hoisted_99 = { key: 0 }
const _hoisted_100 = {
  key: 5,
  class: "mt-10"
}
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "text-success" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-check-circle me-1" }),
  /*#__PURE__*/_createTextVNode(" Prêt à continuer ")
], -1))
const _hoisted_102 = [
  _hoisted_101
]
const _hoisted_103 = {
  key: 3,
  class: "text-danger text-center"
}
const _hoisted_104 = { class: "alert alert-danger" }
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Test impossible à reprendre", -1))
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-10" }, " Aucune question n'est associée à cette session. ", -1))
const _hoisted_107 = { class: "d-flex justify-content-center gap-2" }
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-arrow-left me-1" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_7))
        : (_ctx.showResults)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("div", null, [
                _hoisted_9,
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _hoisted_13,
                      _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.testResults.score) + " / " + _toDisplayString(_ctx.testResults.total), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _hoisted_17,
                      _createElementVNode("p", {
                        class: _normalizeClass(["fs-1 fw-bold", _ctx.testResults.percentage >= 50 ? 'text-success' : 'text-danger'])
                      }, _toDisplayString(_ctx.testResults.percentage) + "% ", 3)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _hoisted_20,
                      _createElementVNode("p", _hoisted_21, _toDisplayString(_ctx.testResults.correctAnswers), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _hoisted_24,
                      _createElementVNode("p", _hoisted_25, _toDisplayString(_ctx.testResults.incorrectAnswers), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _hoisted_27,
                  _createElementVNode("div", _hoisted_28, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.questionsWithAnswers, (question, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: question.id,
                        class: _normalizeClass(["question-review-item mb-15 border", question.isCorrect ? 'border-success' : 'border-danger'])
                      }, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["question-header p-5", question.isCorrect ? 'bg-success-subtle' : 'bg-danger-subtle'])
                        }, [
                          _createElementVNode("div", _hoisted_29, [
                            _createElementVNode("h5", _hoisted_30, [
                              _createElementVNode("span", _hoisted_31, "Question " + _toDisplayString(index + 1), 1)
                            ]),
                            _createElementVNode("span", {
                              class: _normalizeClass(["fs-3", question.isCorrect ? 'text-success' : 'text-danger'])
                            }, _toDisplayString(question.isCorrect ? '✓' : '✗'), 3)
                          ])
                        ], 2),
                        _createElementVNode("div", _hoisted_32, [
                          _createElementVNode("p", _hoisted_33, _toDisplayString(question.contenu), 1),
                          _createElementVNode("div", {
                            class: _normalizeClass(["user-answer mb-5 p-10 rounded", question.isCorrect ? 'bg-light' : 'bg-light'])
                          }, [
                            _hoisted_34,
                            _createElementVNode("span", {
                              class: _normalizeClass(["ms-2 fw-semibold", question.isCorrect ? 'text-success' : 'text-danger text-decoration-line-through'])
                            }, _toDisplayString(question.userAnswerText), 3)
                          ], 2),
                          (!question.isCorrect)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                _hoisted_36,
                                _createElementVNode("span", _hoisted_37, _toDisplayString(question.correctAnswerText), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ], 2))
                    }), 128))
                  ])
                ]),
                (_ctx.completeHistory.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                      _hoisted_39,
                      _hoisted_40,
                      _createElementVNode("div", _hoisted_41, [
                        _createElementVNode("table", _hoisted_42, [
                          _hoisted_43,
                          _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.completeHistory, (result, index) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                key: `history-${index}`,
                                class: _normalizeClass(result.isOriginal ? 'table-primary' : '')
                              }, [
                                _createElementVNode("td", _hoisted_44, [
                                  (result.isOriginal)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_45, [
                                        _hoisted_46,
                                        _createTextVNode("Originale ")
                                      ]))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_47, [
                                        _hoisted_48,
                                        _createTextVNode("Reprise ")
                                      ]))
                                ]),
                                _createElementVNode("td", _hoisted_49, _toDisplayString(result.attempt), 1),
                                _createElementVNode("td", _hoisted_50, _toDisplayString(result.score), 1),
                                _createElementVNode("td", _hoisted_51, _toDisplayString(result.total), 1),
                                _createElementVNode("td", _hoisted_52, [
                                  _createElementVNode("span", {
                                    class: _normalizeClass(result.percentage >= 50 ? 'text-success' : 'text-danger')
                                  }, _toDisplayString(result.percentage) + "% ", 3)
                                ]),
                                _createElementVNode("td", _hoisted_53, _toDisplayString(result.correctAnswers), 1),
                                _createElementVNode("td", _hoisted_54, _toDisplayString(result.incorrectAnswers), 1),
                                _createElementVNode("td", _hoisted_55, _toDisplayString(result.updatedAt ? _ctx.format_date(result.updatedAt) : 'N/A'), 1)
                              ], 2))
                            }), 128))
                          ])
                        ])
                      ]),
                      (_ctx.completeHistory.length > 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                            _createElementVNode("div", _hoisted_57, [
                              _createElementVNode("div", _hoisted_58, [
                                _hoisted_59,
                                _createElementVNode("div", _hoisted_60, [
                                  _createElementVNode("div", _hoisted_61, [
                                    _hoisted_62,
                                    _createElementVNode("span", _hoisted_63, _toDisplayString(_ctx.bestScore.score) + "/" + _toDisplayString(_ctx.bestScore.total) + " (" + _toDisplayString(_ctx.bestScore.percentage) + "%)", 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_64, [
                                    _hoisted_65,
                                    _createElementVNode("span", _hoisted_66, _toDisplayString(_ctx.averagePercentage) + "%", 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_67, [
                                    _hoisted_68,
                                    _createElementVNode("span", _hoisted_69, _toDisplayString(_ctx.completeHistory.length), 1)
                                  ])
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_70, [
                  _createVNode(_component_router_link, {
                    to: "/FaireTest",
                    class: "btn btn-primary"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_71,
                      _createTextVNode(" Nouveau Test ")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_router_link, {
                    to: "/liste-questions",
                    class: "btn btn-info"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_72,
                      _createTextVNode(" Voir les Questions ")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_router_link, {
                    to: "/liste-sessions",
                    class: "btn btn-secondary"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_73,
                      _createTextVNode(" Historique ")
                    ]),
                    _: 1
                  })
                ])
              ])
            ]))
          : (_ctx.questions.length > 0)
            ? (_openBlock(), _createBlock(_component_Form, {
                key: 2,
                ref: "testForm",
                onSubmit: _ctx.handleSubmit,
                "validation-schema": _ctx.testSchema
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_74, [
                    _createElementVNode("div", {
                      class: "progress-bar bg-success",
                      style: _normalizeStyle({ width: _ctx.progressPercentage + '%' })
                    }, null, 4)
                  ]),
                  (_ctx.currentQuestion)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                        _createElementVNode("label", _hoisted_76, " Question " + _toDisplayString(_ctx.currentQuestionIndex + 1) + " / " + _toDisplayString(_ctx.questions.length), 1),
                        _createElementVNode("div", _hoisted_77, [
                          _createElementVNode("strong", null, _toDisplayString(_ctx.currentQuestion.contenu), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.currentQuestion && _ctx.currentQuestion.type === 'choix_multiple')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                        _hoisted_79,
                        (_ctx.propositionOptions.length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.propositionOptions, (proposition, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: `prop-${proposition.value}-${index}`
                                }, [
                                  _createElementVNode("div", _hoisted_81, [
                                    _createVNode(_component_Field, {
                                      name: "answer",
                                      type: "radio",
                                      value: proposition.value,
                                      modelValue: _ctx.formData.answer,
                                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.answer) = $event)),
                                      id: `proposition-${proposition.value}`,
                                      class: "form-check-input me-2",
                                      onChange: _ctx.onAnswerChange
                                    }, null, 8, ["value", "modelValue", "id", "onChange"]),
                                    _createElementVNode("label", {
                                      class: "text-black",
                                      for: `proposition-${proposition.value}`,
                                      style: {"cursor":"pointer"}
                                    }, _toDisplayString(proposition.label), 9, _hoisted_82)
                                  ])
                                ]))
                              }), 128)),
                              _createVNode(_component_ErrorMessage, {
                                name: "answer",
                                class: "text-danger"
                              })
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_83, " Aucune proposition disponible pour cette question. "))
                      ]))
                    : (_ctx.currentQuestion && _ctx.currentQuestion.type === 'texte_libre')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
                          _hoisted_85,
                          _createVNode(_component_Field, {
                            name: "answer",
                            as: "textarea",
                            class: "form-control shadow-none text-black",
                            modelValue: _ctx.formData.answer,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.answer) = $event)),
                            placeholder: "Entrez votre réponse",
                            rows: "4",
                            onInput: _ctx.onAnswerChange
                          }, null, 8, ["modelValue", "onInput"]),
                          _createVNode(_component_ErrorMessage, {
                            name: "answer",
                            class: "text-danger"
                          })
                        ]))
                      : (_ctx.currentQuestion && _ctx.currentQuestion.type === 'oui_non')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
                            _hoisted_87,
                            _createElementVNode("div", _hoisted_88, [
                              _createElementVNode("div", _hoisted_89, [
                                _createVNode(_component_Field, {
                                  name: "answer",
                                  type: "radio",
                                  value: "Oui",
                                  modelValue: _ctx.formData.answer,
                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.answer) = $event)),
                                  id: "oui",
                                  class: "form-check-input me-2",
                                  onChange: _ctx.onAnswerChange
                                }, null, 8, ["modelValue", "onChange"]),
                                _hoisted_90
                              ]),
                              _createElementVNode("div", _hoisted_91, [
                                _createVNode(_component_Field, {
                                  name: "answer",
                                  type: "radio",
                                  value: "Non",
                                  modelValue: _ctx.formData.answer,
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.answer) = $event)),
                                  id: "non",
                                  class: "form-check-input me-2",
                                  onChange: _ctx.onAnswerChange
                                }, null, 8, ["modelValue", "onChange"]),
                                _hoisted_92
                              ]),
                              _createVNode(_component_ErrorMessage, {
                                name: "answer",
                                class: "text-danger"
                              })
                            ])
                          ]))
                        : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_93, [
                    _createElementVNode("button", {
                      type: "button",
                      class: _normalizeClass(["btn btn-secondary me-3", { 'cursor-not-allowed': _ctx.currentQuestionIndex === 0 }]),
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.previousQuestion && _ctx.previousQuestion(...args))),
                      disabled: _ctx.currentQuestionIndex === 0
                    }, " Précédent ", 10, _hoisted_94),
                    _createElementVNode("button", {
                      type: "submit",
                      class: _normalizeClass(["btn", [
              _ctx.isLastQuestion ? 'btn-success' : 'btn-info',
              { 'cursor-not-allowed': _ctx.isDisable }
            ]]),
                      disabled: _ctx.isDisable || _ctx.isSubmitting
                    }, [
                      (_ctx.isSubmitting)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_96))
                        : (_openBlock(), _createElementBlock("i", {
                            key: 1,
                            class: _normalizeClass(_ctx.isLastQuestion ? 'fa fa-check me-1' : 'fa fa-arrow-right me-1')
                          }, null, 2)),
                      _createTextVNode(" " + _toDisplayString(_ctx.isLastQuestion ? 'Terminer le test' : 'Suivant'), 1)
                    ], 10, _hoisted_95)
                  ]),
                  (_ctx.isDisable)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_97, [
                        _createElementVNode("small", _hoisted_98, [
                          (!_ctx.currentQuestion)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_99, "Aucune question disponible"))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_100, _hoisted_102))
                ]),
                _: 1
              }, 8, ["onSubmit", "validation-schema"]))
            : (_openBlock(), _createElementBlock("div", _hoisted_103, [
                _createElementVNode("div", _hoisted_104, [
                  _hoisted_105,
                  _hoisted_106,
                  _createElementVNode("div", _hoisted_107, [
                    _createVNode(_component_router_link, {
                      to: "/liste-sessions",
                      class: "btn btn-primary"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_108,
                        _createTextVNode(" Retour ")
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]))
    ])
  ]))
}